"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceClass = getDeviceClass;
function getDeviceClass(deviceId, deviceConfig) {
    return deviceConfig.atvg_allowlist.indexOf(deviceId) === -1 ? process.env.FAILOVER_SCRIPT_NAME : 'aepg';
}
